import { BaseRequest } from '@/network/requests/BaseRequest'
import { model_side_image } from '@/interfaces/model_side_image'

export const modelSideImageRequest = BaseRequest.build<model_side_image>('model_side_image')

export const getModelSideImageUrlByFileId = async (fileId: string) => {
	var imgSrc = ''
	try {
		var content = await modelSideImageRequest.getFileContentById(fileId, { responseType: 'arraybuffer' })
		var data = content.data

		imgSrc = 'data:image/png;base64,' + btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
	} catch (error) {}

	return imgSrc
}
